import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x",
  "use": "icon-x-usage",
  "viewBox": "0 0 80 79.95",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 79.95\" id=\"icon-x\"><path class=\"jqa\" d=\"M46.79 39.95L78.6 8.14a4.81 4.81 0 0 0 0-6.79 4.93 4.93 0 0 0-6.79 0L40 33.16 8.19 1.35a4.92 4.92 0 0 0-6.79 0 4.8 4.8 0 0 0 0 6.79l31.8 31.81L1.4 71.76a4.8 4.8 0 0 0 0 6.78 4.91 4.91 0 0 0 6.79 0L40 46.73l31.81 31.81a4.8 4.8 0 1 0 6.79-6.78z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol